import * as React from 'react';
import { css } from 'emotion';

let SwapSearchResultItem = (props) => {
    const {
        innerProps,
        innerRef,
        isDisabled,
        isFocused,
        isSelected,
        data,
        className,
        cx,
        getStyles,
        children
    } = props;

    return (
        <div
            className={cx(
                css(getStyles('option', props)),
                {
                    option: true,
                    'option--is-disabled': isDisabled,
                    'option--is-focused': isFocused,
                    'option--is-selected': isSelected
                },
                className
            )}
            title={data.title}
            ref={innerRef}
            {...innerProps}
        >
            <i className={'icon-plan-order md-24'}></i>&nbsp;{children}
        </div>
    );
};

export default SwapSearchResultItem;
